import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus-circle",
  "use": "icon-plus-circle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plus-circle\"><path d=\"M8 0c2.214 0 4.101.78 5.66 2.34C15.22 3.898 16 5.785 16 8s-.78 4.101-2.34 5.66C12.102 15.22 10.215 16 8 16s-4.101-.78-5.66-2.34C.78 12.102 0 10.215 0 8s.78-4.101 2.34-5.66C3.898.78 5.785 0 8 0zm4.571 8.571V7.43h-4v-4H7.43v4h-4v1.14h4v4h1.14v-4h4z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol